import React, { useEffect, useState } from "react";
import { Popover, Grid, Typography, Button, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IFile } from "../../reusable-components/DocumentViewer/interfaces";
import { UserRef } from "../../models/user";
import DocumentViewer from "../../reusable-components/DocumentViewer/DocumentViewer";
import SimplePopover from "../../reusable-components/SimplePopover/SimplePopover";
import LoadingOverlay from "../../containers/LoadingOverlay/LoadingOverlay";
interface Props {
  file: IFile;
  confirmSending: () => Promise<void>;
  users: UserRef[];
  externalUsers: string[];
  loading: boolean;
}

interface State {
  open: boolean;
}

const PreviewProformaEmployeeCostReport = ({ file, confirmSending, users, externalUsers, loading }: Props) => {
  const theme = useTheme();

  const [state, setState] = useState<State>({
    open: false,
  });

  useEffect(() => {
    if (file) {
      setState((state) => ({ ...state, open: true }));
    }
  }, [file]);

  return (
    <>
      <Popover
        open={state.open}
        anchorPosition={{ left: 0, top: 0 }}
        anchorReference={"anchorPosition"}
      >
        {file && (
          <DocumentViewer
            file={file}
            withFooter
          />
        )}
        <LoadingOverlay loading={loading}>
          <Grid style={{ width: "100%", marginBottom: "10px" }}>
            <Grid style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Typography>You are about to send this proforma employee cost report to</Typography>
              <SimplePopover
                buttonType="text"
                buttonContent={`${users.length + externalUsers.length} user${
                  users.length + externalUsers.length > 1 ? "s" : ""
                }`}
                buttonVariant="text"
                children={
                  <Grid style={{ padding: "20px" }}>
                    <Grid>
                      {users.map((user) => (
                        <Typography>{user.email}</Typography>
                      ))}
                    </Grid>
                    {externalUsers.map((user) => (
                      <Grid style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Typography>{user}</Typography>
                        <Chip
                          label="External user"
                          style={{ color: theme.palette.secondary.light, fontSize: "12px" }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                }
                flow="column"
              />
            </Grid>
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <Button
                onClick={() => setState((state) => ({ ...state, open: false }))}
                variant="outlined"
                style={{
                  border: `1px solid ${theme.palette.actions.cancel}`,
                  color: `${theme.palette.actions.cancel}`,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={confirmSending}
              >
                Confirm sending
              </Button>
            </Grid>
          </Grid>
        </LoadingOverlay>
      </Popover>
    </>
  );
};
export default PreviewProformaEmployeeCostReport;
